import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CheckboxModule } from "primeng/checkbox";
import { MultiSelectModule } from "primeng/multiselect";
import { PickListModule } from "primeng/picklist";
import { RatingModule } from "primeng/rating";
import { InputSwitchModule } from "primeng/inputswitch";
import { ProgressBarModule } from "primeng/progressbar";
import { CalendarModule } from "primeng/calendar";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TreeModule } from "primeng/tree";
import { EditorModule } from "primeng/editor";
import { TabViewModule } from "primeng/tabview";
import { ButtonModule } from "primeng/button";
import { AutoCompleteModule } from "primeng/autocomplete";
import { FileUploadModule } from "primeng/fileupload";
import { MenuModule } from "primeng/menu";
import { SlideMenuModule } from 'primeng/slidemenu';
import { DataViewModule } from "primeng/dataview";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PanelModule } from "primeng/panel";
import { CarouselModule } from "primeng/carousel";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TreeTableModule } from "primeng/treetable";
import { TabMenuModule } from 'primeng/tabmenu';
import { MenubarModule } from 'primeng/menubar';
import { ContextMenuModule } from "primeng/contextmenu";
import { TieredMenuModule } from "primeng/tieredmenu";
import { SidebarModule } from "primeng/sidebar";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { ToastModule } from "primeng/toast";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SelectButtonModule } from "primeng/selectbutton";
import { AccordionModule } from "primeng/accordion";
import { CardModule } from "primeng/card";
import { PanelMenuModule } from "primeng/panelmenu";
import { FullCalendarModule } from '@fullcalendar/angular';
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ChartModule } from "primeng/chart";
import { PaginatorModule } from "primeng/paginator";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from "primeng/messages";
import { TagModule } from "primeng/tag";
import { InputMaskModule } from "primeng/inputmask";
import { OverlayModule } from 'primeng/overlay';

// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

const sharedModuless = [
    CommonModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    DragDropModule,
    FormsModule,
    TableModule,
    AutoCompleteModule,
    InputTextModule,
    InputTextareaModule,
    InputIconModule,
    IconFieldModule,
    CheckboxModule,
    MultiSelectModule,
    PickListModule,
    RatingModule,
    ToggleButtonModule,
    InputSwitchModule,
    ProgressBarModule,
    ButtonModule,
    CalendarModule,
    TabViewModule,
    TreeModule,
    EditorModule,
    FileUploadModule,
    MenuModule,
    PaginatorModule,
    ProgressSpinnerModule,
    SlideMenuModule,
    DataViewModule,
    OverlayPanelModule,
    PanelModule,
    CarouselModule,
    ConfirmDialogModule,
    TreeTableModule,
    MenubarModule,
    TabMenuModule,
    ContextMenuModule,
    TieredMenuModule,
    SidebarModule,
    InputNumberModule,
    RadioButtonModule,
    SelectButtonModule,
    ToastModule,
    ScrollPanelModule,
    SelectButtonModule,
    AccordionModule,
    CardModule,
    PanelMenuModule,
    FullCalendarModule,
    BreadcrumbModule,
    ChartModule,
    MessagesModule ,
    TagModule,
    InputMaskModule,
    OverlayModule
    // BrowserAnimationsModule
];
@NgModule({
    declarations: [],
    imports: [...sharedModuless],
    exports: [...sharedModuless],
})
export class PrimngDesignModule {}
